<template>
  <div class="grid place-content-center text-center">
    <div class="flex flex-col items-center">
      <DotLottieVue
        v-if="!hideIcon"
        class="h-40 w-40 mt-8"
        autoplay
        loop
        src="/animations/error.lottie"
      />
    </div>
    <p class="text-red-500 font-bold text-xl mb-1">{{ $t("errors.error") }}</p>
    <p class="text-center max-w-lg">
      {{ message || $t("errors.tryAgain") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";
defineProps<{
  message?: string;
  hideIcon?: boolean;
}>();
</script>
